import { render } from "./GetStartedBanner.vue?vue&type=template&id=68de8ace&scoped=true"
import script from "./GetStartedBanner.vue?vue&type=script&lang=js"
export * from "./GetStartedBanner.vue?vue&type=script&lang=js"

import "./GetStartedBanner.vue?vue&type=style&index=0&id=68de8ace&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-68de8ace"

export default script